'use strict';

/**
 * A little component that shows the current user and his subscription.
 */
customerZone.component('customerInfo', {
    templateUrl: customerZone.fromBase('components/customer-info/customer-info.component.html'),
    bindings: {
        subscriber: '<'
    },
    controller: ['$log', 'Session', 'config', 'SubscriptionService', function(
        $log, session, config, SubscriptionService){
        var vm = this;
        vm.userIsAuthenticated = session.authenticated();
        vm.profile = session.profile();
        vm.subscriptionsUrl = config.mainUrls.subscriptions;

        vm.migrationOptions = [];

        var initMigrationOptions = function() {
            SubscriptionService.getMigrationOptions(vm.subscriber)
                .then(function (options) {
                    vm.migrationOptions = options.map(function (product) {
                        return {
                            url: '#!/migration?product=' + product.id,
                            product: product
                        };
                    });
                })
                .catch(function (error) {
                    $log.error('Failed to load migration options', error);
                });
        };

        vm.allowsModification = function(){
            if (!vm.subscriber) return false;
            if (vm.subscriber.state !== jim.SubscriberState.enabled) return false;
            if (!vm.subscriber.sim) return false;
            if (vm.subscriber.isCancelled()) return false;
            if (session.flags('postpaid_on_transatel')) return false;
            return vm.migrationOptions.length > 0 || vm.subscriber.isPostpaid();
        };

        vm.isMainSubscriber= function(){
            return session.subscriber() && vm.subscriber && (vm.subscriber.id === session.subscriber().id);
        };

        vm.$postLink = function(){
            if (!vm.subscriber) vm.subscriber = session.subscriber();
            initMigrationOptions();
        };
    }],
    controllerAs: 'vm'
});
